import React, {useState} from 'react';
import logoSpid from "../../img/icons/spid.PNG";
import Icon from "../../components/icon/Icon";
import logoRegione from "../../img/logo/regioneVeneto.PNG"
import logoSpidFondoPagina from "../../img/logo/spid.PNG"
import Spinner from "../../components/spinner/Spinner";

function Login(props) {

    const [showSpinner, setShowSpinner] = useState(false)

    function onClickSpid() {
        setShowSpinner(true)
    }

    return (
        <div style={{marginTop: "5rem"}}>
            <Spinner show={showSpinner}/>
            <div style={{textAlign: "center", margin: "auto", width: "50%"}}>
                <Icon path={logoRegione}/>
            </div>
            <div style={{textAlign: "center", margin: "auto", width: "40%"}}>
                <span>Entra con il Sistema pubblico per la gestione dell'identità Digitale</span>
            </div>
            <div style={{
                textAlign: "center",
                marginLeft: "auto", marginRight: "auto", marginBottom: "auto", marginTop: "2rem",
                width: "20%",
                background: "#06C",
                height: "60px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer"
            }} onClick={onClickSpid}>
                <div style={{width: "30%", borderRight: "1px solid white"}}>
                    <Icon height={"60"} width={"60"} path={logoSpid}/>
                </div>
                <div style={{width: "70%"}}>
                    <span style={{color: "white", fontSize: "20px"}}>Entra con SPID</span>
                </div>
            </div>
            <div style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "auto",
                marginTop: "2rem",
                width: "40%",
                textAlign: "left"
            }}>
                <span>SPID è il sistema di accesso che
                consente di utilizzare, con un'identità  digitale unica, i servizi online della pubblica amministrazione
                e dei privati accreditati.</span>
            </div>
            <div style={{
                marginLeft: "auto", marginRight: "auto", marginBottom: "auto", marginTop: "1rem",
                width: "40%", textAlign: "left"
            }}>
                <a href="#">Maggiori informazioni su SPID</a>
                <br/>
                <a href="#">Come ottenere le credenziali SPID</a>
            </div>
            <div style={{
                marginLeft: "auto", marginRight: "auto", marginBottom: "auto", marginTop: "4rem",
                width: "50%", textAlign: "center"
            }}>
                <Icon path={logoSpidFondoPagina}/>
            </div>
        </div>
    );
}

export default Login;
